import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Placeholder from '../../components/molecule/Placeholder';
import * as Constants from '../../core/constants';
import CardGrid from '../../components/organism/CardGrid';
import InfoCard from '../../components/molecule/Cards/InfoCard';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getExerciseLibrary, isLibraryLoading, libraryLoaded, exerciseQuery, exerciseBase } from '../../modules/Exercise';
import searchController from '../../components/hoc/searchController';
import SearchBar from '../../components/organism/SearchBar';
import { getResources } from '../../modules/Resource';
import { createSelects, createSelect, displayTags } from '../../utils';
import { toast } from 'react-toastify';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // height: 100%;
`
const CardGridStyled = styled(CardGrid)`

`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 115px;
`

const PlaceholderStyled = styled(Placeholder)`
  margin: 100px auto;
`

const ExerciseSearch = searchController(SearchBar, 'exercises', { params: { page_size: Constants.PER_PAGE_DEFAULT } });

class ExerciseLibrary extends Component {
  constructor(props) {
    super(props);
    this.selects = [];
    this.state = {
      page: Constants.START_PAGE_DEFAULT,
      perPage: Constants.PER_PAGE_DEFAULT,
      gotoNext: false,
    };
  }

  async componentDidMount() {
    const { getResources, resourceState, getExerciseLibrary, exerciseBase } = this.props;
    const { page, perPage } = this.state;

    const initialSelect = createSelect('Status', 'Choose a status', 'filter', [
      {
        label: 'Completed',
        value: 'valid'
      },
      {
        label: 'Incomplete',
        value: 'invalid'
      },
    ], false);
    this.selects = [initialSelect];

    try {
      if(!resourceState.resourceData){
        await getResources();
      }
      exerciseBase();
      await getExerciseLibrary({ params: { page, page_size: perPage } });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  renderCard = (item, index) => {
    const { history } = this.props;
    return (
      <InfoCard
        key={`${index}-${item.name}`}
        header={item.name}
        subtext1={displayTags(item.tags)}
        subtext2={item.equipment.map(e => e.name).join(', ')}
        chips={item.musclegroup.map(m => m.name)}
        onClick={() => history.push(`/exercises/${item.id}`, { exercise: item })}
      />
    )
  }

  onNext = () => {
    const { exerciseState } = this.props;
    const { totalCount, exercises } = exerciseState;
    if(exercises && totalCount && exercises.length < totalCount && !exerciseState.isLoading) {
      this.setState({gotoNext: true})
    }
  }

  libraryDidLoad = (results, count, query) => {
    this.props.libraryLoaded(results, count, query);
    this.setState({gotoNext: false});
  }

  startQuery = () => {
    const { exerciseQuery, exerciseState } = this.props;
    if(!exerciseState.isLoading) {
      exerciseQuery();
    }
  }

  render() {
    const { exerciseState, isLibraryLoading, resourceState, modalComponent, authState: {userData} } = this.props
    const { perPage, gotoNext } = this.state;
    const isAdmin = userData?.is_superuser;

    const includedSelects = {
      cat: true,
      mg: true,
      il: false,
      eq: false,
      fg: false,
      tr: isAdmin,
    };

    return (
      <Container>
        <ExerciseSearch
          selects={createSelects(resourceState.resourceData, this.selects, includedSelects)}
          getter={isLibraryLoading}
          setter={this.libraryDidLoad}
          base={this.startQuery}
          gotoNext={gotoNext}
          perPage={perPage}
        />
        <Scrollable>
          {
            (
              exerciseState.exercises.length <= 0 &&
              !exerciseState.isLoading &&
              exerciseState.query === ''
            ) ? (
              <PlaceholderStyled
                title="No Exercises Found"
                subtext={[
                  'To create an exercise',
                  'Click below'
                ]}
                modalComponent={modalComponent}
                buttonIcon='add'
                buttonText='create exercise'
              />
            ) : (
              <CardGridStyled
                data={exerciseState.exercises}
                renderItem={(item,index) => this.renderCard(item,index)}
                nextPage={this.onNext}
                isLoading={exerciseState.isLoading}
              />
            ) 
          }
        </Scrollable>
      </Container>
    )
  }
}

ExerciseLibrary.propTypes = {
};

ExerciseLibrary.defaultProps = {
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    resourceState: state.resourceState,
    exerciseState: state.exerciseState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    getExerciseLibrary: getExerciseLibrary,
    isLibraryLoading: isLibraryLoading,
    libraryLoaded: libraryLoaded,
    exerciseQuery: exerciseQuery,
    exerciseBase: exerciseBase
  }, dispatch)
}


export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(ExerciseLibrary);
